import { IsMobileService } from '@shared/services/is-mobile.service';
import { ChangeDetectionStrategy, Component, ContentChild, EventEmitter, inject, Input, Output, TemplateRef } from '@angular/core';
import { BaseComponent } from 'src/app/core/utilities/base-component/base-component';

@Component({
  selector: 'sigecom-offcanvas',
  template: `
    <sigecom-button [title]="!(isMobile$ | async) ? 'Filtros' : ''" [class]="buttonClass" icon="filter" (buttonClicked)="toggleMenu()"/>

    <!-- ── Desktop: offcanvas slide-in panel ── -->
    <ng-container *ngIf="!(isMobile$ | async)">
      <div *ngIf="open" (click)="toggleMenu()" class="fixed top-0 left-0 right-0 bottom-0 bg-black opacity-50 z-[130]"></div>
      <div id="menu" [ngClass]="{'menu-open': open, 'menu-closed': !open}" class="fixed top-0 right-0 w-[25rem] max-h-screen overflow-y-auto h-screen flex bg-white duration-300 z-[130]">
        <div class="w-full flex flex-col gap-4 text-black px-5 py-4 mt-4 space-y-4 overflow-y-auto">
          <div class="flex justify-between items-center">
            <h4 class="text-2xl font-bold text-[#333333]">Filtros</h4>
            <a (click)="toggleMenu()" class="text-right text-4xl hover:text-red-400 cursor-pointer">&times;</a>
          </div>
          <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
        </div>
      </div>
    </ng-container>

    <!-- ── Mobile: centered modal dialog ── -->
    <ng-container *ngIf="(isMobile$ | async) && open">
      <!-- backdrop -->
      <div (click)="toggleMenu()" class="fixed inset-0 bg-black opacity-50 z-[130]"></div>
      <!-- modal -->
      <div class="fixed inset-0 flex items-center justify-center z-[131] px-4">
        <div class="bg-white rounded-2xl shadow-xl w-full max-w-sm max-h-[90vh] flex flex-col">
          <!-- modal header -->
          <div class="flex justify-between items-center px-5 py-4 border-b border-gray-200">
            <h4 class="text-2xl font-bold text-[#333333]">Filtros</h4>
            <button (click)="toggleMenu()" class="text-4xl leading-none hover:text-red-400 cursor-pointer text-gray-500">&times;</button>
          </div>
          <!-- modal body -->
          <div class="flex flex-col gap-4 px-5 py-4 overflow-y-auto">
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  `,
  styleUrls: ['./offcanvas.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OffcanvasComponent extends BaseComponent {
  @Input() buttonClass = '';
  @Output() clearForm: EventEmitter<boolean> = new EventEmitter();

  @ContentChild(TemplateRef) contentTemplate!: TemplateRef<any>;

  open: boolean = false;

  private readonly isMobileService = inject(IsMobileService);
  readonly isMobile$ = this.isMobileService.isMobile$;

  constructor() { super() }

  toggleMenu() {
    this.open = !this.open;
    this.clearForm?.emit(this.open);
  }
}
